"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const cardGridStyle = theme => ({
    borderRadius: '10px',
    padding: '10px',
    backgroundColor: theme === 'light' ? '#FFFFFF' : '#272936'
});
const gridStyle = {
    height: '100%'
};
const footerStyle = {
    textAlign: 'right',
    marginTop: '10px'
};
const button = (theme) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: 8,
    height: 40,
    padding: '12px 20px',
    backgroundColor: theme === 'light' ? constants_1.color.redDark : constants_1.color.buttonDark,
});
const buttonFont = {
    fontSize: '16px',
    fontWeight: 'normal',
    margin: 0,
    marginLeft: 8,
};
exports.default = {
    button,
    gridStyle,
    buttonFont,
    footerStyle,
    cardGridStyle,
};
